import { render, staticRenderFns } from "./SupplierWallet.vue?vue&type=template&id=4ddf61d9&scoped=true&"
import script from "./SupplierWallet.vue?vue&type=script&lang=js&"
export * from "./SupplierWallet.vue?vue&type=script&lang=js&"
import style0 from "./SupplierWallet.vue?vue&type=style&index=0&id=4ddf61d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf61d9",
  null
  
)

export default component.exports